module.exports = __webpack_public_path__ + "static/media/level_g_icon.d18921a4.png";